<template>
  <div class="header-bottom">
    <div class="d-flex justify-content-around">
      <div class="item-bottom" @click="toListTax()" v-if="hasPermission('good-baogia.index') || hasPermission('quote-clean-baogia.index') || hasPermission('quote-baogia.create')">
        <template v-if="isServiceActive">
          <div class="circle-menu">
            <img
              class="img-bottom"
              src="@/static/images/footer/hanghoa_w.svg"
              alt="Home Icon"
            />
          </div>
        </template>
        <template v-else>
          <img
            class="img-bottom"
            src="@/static/images/footer/hanghoa.svg"
            alt="Home Icon"
          />
        </template>
        <div class="text-center text-bottom">{{ language.menu_service || 'Dịch vụ' }}</div>
      </div>
      <div class="item-bottom text-center" @click="toCustoms()" v-if="hasAnyPermission(customsPermissions)">
        <template v-if="isCustomsActive">
          <div class="circle-menu">
            <img
              class="img-bottom"
              src="@/static/images/footer/baogia_w.svg"
              alt="Home Icon"
            />
          </div>
        </template>
        <template v-else>
          <img
            class="img-bottom"
            src="@/static/images/footer/baogia.svg"
            alt="Home Icon"
          />
        </template>
        <div class="text-center text-bottom">Hải quan</div>
      </div>
      <div class="item-bottom" @click="toQuoteReport()" v-if="hasPermission('quote-baogia.index')">
        <template v-if="checkFullPath('quote/report')">
          <div class="circle-menu">
            <img
              class="img-bottom"
              src="@/static/images/footer/lichsu_w.svg"
              alt="Home Icon"
            />
          </div>
        </template>
        <template v-else>
          <img
            class="img-bottom"
            src="@/static/images/footer/lichsu.svg"
            alt="Home Icon"
          />
        </template>
        <div class="text-center text-bottom">Báo cáo</div>
      </div>
      <div class="item-bottom" @click="toQuoteAccountant()" v-if="hasPermission('accountant.index')">
        <template v-if="checkFullPath('declaration')">
          <div class="circle-menu">
            <img
              class="img-bottom"
              src="@/static/images/footer/accountant_w.svg"
              alt="Home Icon"
            />
          </div>
        </template>
        <template v-else>
          <img
            class="img-bottom"
            src="@/static/images/footer/accountant.svg"
            alt="Home Icon"
          />
        </template>
        <div class="text-center text-bottom">{{ language.menu_accountant }}</div>
      </div>
      <div class="item-bottom text-center" @click="toListSetting()">
        <template v-if="checkFullPath('setting/')">
          <div class="circle-menu">
            <img
              class="img-bottom"
              src="@/static/images/footer/caidat_w.svg"
              alt="Home Icon"
            />
          </div>
        </template>
        <template v-else>
          <img
            class="img-bottom"
            src="@/static/images/footer/caidat.svg"
            alt="Home Icon"
          />
        </template>
        <div class="text-center text-bottom">{{ language.menu_setting }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "LayoutFooter",
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters("account", ["accountInfo", "language"]),
    ...mapGetters(["path", "full_path"]),
    customsPermissions() {
      return [
        "awaiting-confirmation.view-all",
        "awaiting-confirmation.view-all-agency",
        "quote-clean-baogia.index",
        "quote-file-baogia.index",
        "quote-file-baogia.view-wh-release-note",
        "import-warehouse.index-all",
        "import-warehouse.index-company",
        "import-warehouse.index-agency",
        "cleared_custom.index",
      ];
    },
    isCustomsActive() {
      return [
        "customs-home",
        "customs-clearance-menu",
        "goods-awaiting-confirmation",
        "tax/goods-awaiting-clearance",
        "tax/goods-cleared-custom",
        "tax/list-file-xnk",
        "tax/warehouse-release-note",
        "tax/import-warehouse",
      ].includes(this.$route.name);
    },
    isServiceActive() {
      return this.$route.name === "goods-home" ||
        (this.full_path.startsWith("/tax/") && !this.isCustomsActive);
    },
  },
  mounted() {},
  methods: {
    ...mapActions("account", ["getAccountInfo"]),
    ...mapActions("account", ["removeAccountInfo"]),
    checkFullPath(text) {
      return this.full_path.includes(text);
    },
    toListTax() {
      if (this.$route.name === "goods-home") {
        return;
      }
      this.$router.push({ name: "goods-home" });
    },
    toCustoms() {
      if (this.$route.name === "customs-home") {
        return;
      }
      this.$router.push({ name: "customs-home" });
    },
    toListSetting() {
      if (this.full_path.includes("/setting/list")) {
        return;
      }
      this.$router.push({ name: "setting-list" });
    },
    toQuoteReport() {
      if (this.full_path.includes("/quote/report")) {
        return;
      }
      this.$router.push({ name: "report-list" });
    },
    toQuoteAccountant() {
      if (this.full_path.includes("home/accountant")) {
        return;
      }
      this.$router.push({ name: "home-accountant" });
    },
    hasPermission(permission) {
      return this.permissionNames().includes(permission);
    },
    permissionNames() {
      if (!this.accountInfo || !Array.isArray(this.accountInfo.permissions)) {
        return [];
      }
      return this.accountInfo.permissions.map((permission) => permission.name);
    },
    hasAnyPermission(permissions) {
      const permissionNames = this.permissionNames();
      return permissions.some((permission) => permissionNames.includes(permission));
    },
  },
  watch: {},
};
</script>

<style lang="css" scoped>
.header-bottom {
  height: 80px;
  width: 100%;
  background: #ffffff;
  box-shadow: inset 0px 2px 8px rgba(185, 188, 190, 0.1);
  border-radius: 8px;
  z-index: 999;
}

.item-bottom {
  padding: 15px 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.img-bottom {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.text-bottom {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.02em;
  color: #989898;
  margin-top: 5px;
}
.circle-menu {
  width: 47px;
  height: 47px;
  background-color: #285ff8;
  border-radius: 23px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -27px;
}
</style>
